/*
 * @Description: 获取慧教云网关toekn
 * @Author: luozhao
 * @Date: 2021-04-07 09:34:42
 */

import axios from 'axios';
/**
 * @description: 获取天喻云统一网关访问 userToken
 * @author luozhao
 * @export
 * @param {String} ticket
 * @param {String} loginPlatformCode: 实体平台码
 * @returns
 */
export async function getToken() {
  var userToken = ''

  const response = await axios({
    url: `https://cms-api.wuhaneduyun.cn/gateway/respriv/getTyuAccessToken`,
    method: 'get',
  });
  console.log(response)
  userToken = response.data.data.tokenInfo.accessToken;

  return userToken;
}